import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../App';
import Navbar from '../components/Navbar';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import axios from 'axios';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { token, API } = useAuth();
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      pollPaymentStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const pollPaymentStatus = async () => {
    if (attempts >= 5) {
      setStatus('timeout');
      return;
    }

    try {
      const response = await axios.get(`${API}/payments/status/${sessionId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.payment_status === 'paid' || response.data.status === 'already_processed') {
        setStatus('success');
      } else {
        setAttempts(prev => prev + 1);
        setTimeout(pollPaymentStatus, 2000);
      }
    } catch (error) {
      setAttempts(prev => prev + 1);
      setTimeout(pollPaymentStatus, 2000);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="max-w-lg mx-auto px-4 py-24">
        <Card className="card-dashboard">
          <CardContent className="py-12 text-center">
            {status === 'checking' && (
              <>
                <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-6"></div>
                <h2 className="font-heading text-2xl font-bold mb-2">
                  Vérification du paiement...
                </h2>
                <p className="text-muted-foreground">
                  Veuillez patienter pendant que nous confirmons votre paiement
                </p>
              </>
            )}

            {status === 'success' && (
              <>
                <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
                  <CheckCircle className="w-10 h-10 text-green-500" />
                </div>
                <h2 className="font-heading text-2xl font-bold mb-2 text-green-500">
                  Paiement réussi !
                </h2>
                <p className="text-muted-foreground mb-8">
                  Votre transaction a été confirmée. Les fonds sont en séquestre 
                  et seront libérés au vendeur après confirmation de la livraison.
                </p>
                <div className="flex flex-col gap-3">
                  <Button 
                    className="btn-primary"
                    onClick={() => navigate('/buyer')}
                    data-testid="go-dashboard-btn"
                  >
                    Suivre ma commande
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                  <Button 
                    variant="outline"
                    onClick={() => navigate('/support')}
                  >
                    Contacter le support
                  </Button>
                </div>
              </>
            )}

            {status === 'timeout' && (
              <>
                <div className="w-20 h-20 rounded-full bg-yellow-500/20 flex items-center justify-center mx-auto mb-6">
                  <CheckCircle className="w-10 h-10 text-yellow-500" />
                </div>
                <h2 className="font-heading text-2xl font-bold mb-2">
                  Paiement en cours de traitement
                </h2>
                <p className="text-muted-foreground mb-8">
                  La confirmation prend plus de temps que prévu. 
                  Vérifiez votre tableau de bord pour le statut final.
                </p>
                <Button 
                  className="btn-primary"
                  onClick={() => navigate('/buyer')}
                >
                  Voir mes commandes
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
